export const FIELDS = {

  ID: 'id',
  PODATE: 'poDate',
  DUE_DATE: 'dueDate',
  COMPANY_ID: 'companyId',
  CONTACT_ID: 'contactId',
  BILLING_ADDRESS_ID: 'billingAddressId',
  SHIPPING_ADDRESS_ID: 'shippingAddressId',
  BUYER_USER_ID: 'buyerUserId',
  BILLING_TERM_ID: 'billingTermId',
  COMMENTS: 'comments',
  INTERNAL_COMMENTS: 'internalComments',
  SHIPPING_METHOD_ID: 'shippingMethodId',
  SHIP_ON_VENDOR_ACCOUNT: 'shipOnVendorAccount',
  ALWAYS_SHIP_BY: 'alwaysShipBy',
  SHIPPING_ACCOUNT_NUMBER: 'shippingAccountNumber',
  TRACKING_NUMBER: 'trackingNumber',
  STATUS_ID: 'statusId',
  SALES_TYPE_ID: 'salesTypeId',
  INCO_TERM_ID: 'incoTermId',
  CURRENCY_TYPE_ID: 'currencyTypeId',
  EXCHANGE_RATE: 'exchangeRate',
  IS_TAXABLE: 'isTaxable',
  TAX_RATE: 'taxRate',
  SHIPPING_NO_CHARGE: 'shippingNoCharge',
  SHIPPING_CHARGE: 'shippingCharge',
  SUB_TOTAL: 'subTotal',
  TOTAL_LINE_COST: 'totalLineCost',
  TOTAL_CHARGES_TAXABLE: 'totalChargesTaxable',
  TOTAL_CHARGES_NON_TAXABLE: 'totalChargesNonTaxable',
  TOTAL_CHARGES: 'totalCharges',
  TOTAL_CHARGES_COST: 'totalChargesCost',
  TAX: 'tax',
  CREDIT: 'credit',
  TOTAL: 'total',
  SUB_TOTAL_CONVERTED: 'subTotalConverted',
  TOTAL_LINE_COST_CONVERTED: 'totalLineCostConverted',
  TOTAL_CHARGES_TAXABLE_CONVERTED: 'totalChargesTaxableConverted',
  TOTAL_CHARGES_NON_TAXABLE_CONVERTED: 'totalChargesNonTaxableConverted',
  TOTAL_CHARGES_CONVERTED: 'totalChargesConverted',
  TOTAL_CHARGES_COST_CONVERTED: 'totalChargesCostConverted',
  TOTAL_CONVERTED: 'totalConverted',
  AMOUNT_PAID: 'amountPaid',
  BALANCE: 'balance',
  CREDIT_AMOUNT: 'creditAmount',
  IS_PAID: 'isPaid',
  ON_HOLD: 'onHold',
  IS_DROP_SHIP: 'isDropShip',
  IS_AUTHORIZED: 'isAuthorized',
  AUTHORIZED_BY_USER_ID: 'authorizedByUserId',
  DATE_AUTHORIZED: 'dateAuthorized',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_SENT: 'dateSent',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  PONUMBER: 'poNumber',
  AGING: 'aging',
  COMPANY_NAME: 'companyName',
  CONTACT_FULL_NAME: 'contactFullName',
  CONTACT_EMAIL: 'contactEmail',
  BILLING_ADDRESS: 'billingAddress',
  SHIPPING_ADDRESS: 'shippingAddress',
  BUYER_FULL_NAME: 'buyerFullName',
  AUTHORIZED_BY_USER_FULL_NAME: 'authorizedByUserFullName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  SHIPPING_PROVIDER_ID: 'shippingProviderId',
  SHIPPING_PROVIDER_NAME: 'shippingProviderName',
  SHIPPING_METHOD_NAME: 'shippingMethodName',
  STATUS_NAME: 'statusName',
  SALES_TYPE_NAME: 'salesTypeName',
  BILLING_TERM_NAME: 'billingTermName',
  CURRENCY_TYPE_NAME: 'currencyTypeName',
  TAX_NUMBER: 'taxNumber',
};